import { Row } from '@tanstack/react-table';
import { PositionView } from '@paradigm/features/src/positions/entities/positions';

export const getGroupPositions = (groupRow: Row<PositionView>) =>
  groupRow
    .getLeafRows()
    .filter((row) => !row.getIsGrouped())
    .map((row) => row.original);
